module.exports = __webpack_public_path__ + "img/home-solution-qixiang.563f9089.png";